import {gsap} from "gsap";
import Isotope from 'isotope-layout';
import 'isotope-packery';
import 'isotope-cells-by-row';
import lightGallery from 'lightgallery';
import lgZoom from 'lightgallery/plugins/zoom';
import CustomAnimation from "src/scripts/modules/CustomAnimation";
import 'slick-carousel';
import 'jquery-validation';

let iso;
const animations = new CustomAnimation();

// Helper: auf reCAPTCHA v3 warten (mit Timeout)
function waitForRecaptcha(timeout = 8000) {
  return new Promise((resolve, reject) => {
    const ready = () => (typeof window.grecaptcha !== 'undefined') && (typeof window.grecaptcha.execute === 'function');
    if (ready()) {
      window.grecaptcha.ready(resolve);
      return;
    }
    const start = Date.now();
    const timer = setInterval(() => {
      if (ready()) {
        clearInterval(timer);
        window.grecaptcha.ready(resolve);
      } else if (Date.now() - start > timeout) {
        clearInterval(timer);
        reject(new Error('reCAPTCHA wurde nicht geladen (Timeout).'));
      }
    }, 150);
  });
}

// magnetic
const magneticRadius = window.innerWidth * 0.05;//150;
function resetMagnet(button, text) {
  gsap.to(button, {
    x: 0,
    y: 0,
    duration: 2.5,
    ease: "elastic.out(1.2, 0.2)"
  });

  gsap.to(text, {
    x: 0,
    y: 0,
    duration: 0.5,
    ease: "power3.out"
  });
}



class Home {

  init() {
    this.initListener();
    this.initPage();
    this.initIsotope();
    this.initLightGallery();
    this.initBewertungCaroussel();
    this.initForm();
    this.onResize();
  }

  initListener = () => {

    $('.button_faq').click(function(e){
      e.preventDefault();

      $(this).next(".faq_content").slideToggle();
      $(this).closest("li").siblings().find('.faq_content').slideUp();

      if( $(this).hasClass('open') ) {
        $('.button_faq').removeClass("open");
        $(this).removeClass('open')
      }
      else {
        $('.button_faq').removeClass("open");
        $(this).addClass('open')
      }
    });
  }

  initPage = () => {
    document.addEventListener("mousemove", (e) => {
      // Loop through all buttons only when necessary
      const buttons = document.querySelectorAll(".magnetic-button");

      buttons.forEach((button) => {
        const rect = button.getBoundingClientRect();
        const buttonCenterX = rect.left + rect.width / 2;
        const buttonCenterY = rect.top + rect.height / 2;

        const distanceX = e.clientX - buttonCenterX;
        const distanceY = e.clientY - buttonCenterY;
        const distance = Math.sqrt(distanceX ** 2 + distanceY ** 2);

        const text = button.querySelector("span");

        if (distance < magneticRadius) {
          const offsetX = e.clientX - rect.left - rect.width / 2;
          const offsetY = e.clientY - rect.top - rect.height / 2;

          // Move button and text with GSAP
          gsap.to(button, {
            x: offsetX * 0.5,
            y: offsetY * 0.5,
            duration: 0.5,
            ease: "power3.out",
            overwrite: "auto" // Allow overwriting previous animations
          });

          gsap.to(text, {
            x: offsetX * 0.2,
            y: offsetY * 0.2,
            duration: 0.5,
            ease: "power3.out",
            overwrite: "auto" // Allow overwriting previous animations
          });
        } else {
          // Throttle the resetMagnet function so it's not triggered too often
          if (!button.resetTimer) {
            button.resetTimer = setTimeout(() => {
              resetMagnet(button, text);
              button.resetTimer = null; // Reset the timer after execution
            }, 200); // Throttle reset to be triggered only once every 200ms
          }
        }
      });
    });

  }

  initIsotope = () => {

    iso = new Isotope('.grid', {
      itemSelector: '.grid-item',
      originTop: true,
      layoutMode: 'packery',
      packery: {
        gutter: '.gutter-sizer'
      },
      percentPosition: true
    });

    setTimeout(function () {
      iso.layout();
    }, 1500);
  }

  initLightGallery = () => {

    lightGallery(document.getElementById('lightgallery'), {
      plugins: [lgZoom],
      selector: '.grid-item',
      download: false,
      counter: true,
      nextHtml: '',
      prevHtml: '',
      hideBarsDelay: 0,
      zoom: false,
      thumbnail: false,
      autoplay: false,
      share: false,
      autoplayControls: false,
      resetScrollPosition: false,
      fullScreen: false,
      loop: true,
      speed: 600,
      zoomFromOrigin: false,
      mode: 'lg-slide',
      mobileSettings: { controls: false, showCloseIcon: true }
    });

    let lastScrollY = 0;


    const lightgallery = document.getElementById('lightgallery');
    lightgallery.addEventListener('lgBeforeOpen', () => {
      lastScrollY = animations.getSmoother().scrollTop();
      animations.getSmoother().paused(true);

      //jQuery('body').addClass('overflow-hidden');

    });

    lightgallery.addEventListener('lgAfterOpen', () => {
      animations.getSmoother().scrollTo(lastScrollY, true);
    });

    lightgallery.addEventListener('lgBeforeClose', () => {
      animations.getSmoother().scrollTo(lastScrollY, false);
      animations.getSmoother().paused(false);
      //jQuery('body').removeClass('overflow-hidden');

    });

  }

  initBewertungCaroussel = () => {
    this.slick = $('.bewertungen_caroussel').slick({
      slidesToShow: 1,
      dots: true,
      centerMode: false,
      adaptiveHeight: true
    });
  }

  initFormOrg = () => {
    this.resetForm();
    const that = this;

    jQuery("#contact_form").validate({

      rules: {
        name: 'required',
        email: {
          required: true,
          email: true
        },
        message:'required',
        policy:'required'
      },
      messages: {
        name: 'Bitte geben Sie Ihren Namen ein.',
        email: 'Bitte geben Sie Ihre korrekte E-Mail ein.',
        message: 'Bitte geben Sie Ihre Nachricht ein.',
        policy: 'Bitte akzeptieren Sie die Datenschutzbestimmungen.'
      },
      submitHandler: function (form) {
        // Führe die Google reCAPTCHA v3-Abfrage durch
        grecaptcha.execute('6Lfr3OkrAAAAAHeMDRAvZdqLzOPE3DYNM4ShDy6G', { action: 'submit' }).then(function (token) {
          // Füge das reCAPTCHA-Token zum Formular hinzu
          const recaptchaInput = document.createElement('input');
          recaptchaInput.type = 'hidden';
          recaptchaInput.name = 'g-recaptcha-response';
          recaptchaInput.value = token;
          form.appendChild(recaptchaInput);

          // Sende das Formular per AJAX
          const $form = $(form);
          $.ajax({
            url: $form.attr("action"),
            type: $form.attr("method"),
            data: $form.serialize(), // Alle Formulardaten inkl. Token
            dataType: "json",
            success: function (response) {
              const messageContainer = document.getElementById('form-messages'); // ID des Containers
              if (response.success) {
                // Erfolgsmeldung anzeigen
                messageContainer.innerHTML = `<div class="alert alert-success">${response.message}</div>`;
                $form.trigger("reset"); // Formular zurücksetzen
                that.resetForm();
              } else {
                // Fehlermeldung anzeigen
                messageContainer.innerHTML = `<div class="alert alert-danger">${response.message}</div>`;
              }

            },
            error: function () {
              // Generelle Fehlermeldung bei AJAX-Fehlern
              const messageContainer = document.getElementById('form-messages'); // ID des Containers
              messageContainer.innerHTML = `<div class="alert alert-danger">Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.</div>`;
              //$form.trigger("reset");
              that.resetForm();
            },
          });
        });

        return false; // Verhindert das standardmäßige Absenden des Formulars
      },

    });

  }

  initForm = () => {
    this.resetForm();
    const that = this;

    jQuery("#contact_form").validate({

      rules: {
        name: 'required',
        email: {
          required: true,
          email: true
        },
        message: 'required',
        policy: 'required'
      },
      messages: {
        name: 'Bitte geben Sie Ihren Namen ein.',
        email: 'Bitte geben Sie Ihre korrekte E-Mail ein.',
        message: 'Bitte geben Sie Ihre Nachricht ein.',
        policy: 'Bitte akzeptieren Sie die Datenschutzbestimmungen.'
      },
      submitHandler: function (form) {
        const siteKey = '6Lfr3OkrAAAAAHeMDRAvZdqLzOPE3DYNM4ShDy6G'; // v3 Site Key

        // Auf reCAPTCHA warten (auch wenn via Consent erst spät geladen)
        waitForRecaptcha(8000)
          .then(() => window.grecaptcha.execute(siteKey, {action: 'submit'}))
          .then((token) => {
            // Token anhängen
            const recaptchaInput = document.createElement('input');
            recaptchaInput.type = 'hidden';
            recaptchaInput.name = 'g-recaptcha-response';
            recaptchaInput.value = token;
            form.appendChild(recaptchaInput);

            // AJAX senden
            const $form = $(form);
            $.ajax({
              url: $form.attr("action"),
              type: $form.attr("method"),
              data: $form.serialize(),
              dataType: "json",
              success: function (response) {
                const messageContainer = document.getElementById('form-messages');
                if (response.success) {
                  messageContainer.innerHTML = `<div class="alert alert-success">${response.message}</div>`;
                  $form.trigger("reset");
                  that.resetForm();
                } else {
                  messageContainer.innerHTML = `<div class="alert alert-danger">${response.message}</div>`;
                }
              },
              error: function () {
                const messageContainer = document.getElementById('form-messages');
                messageContainer.innerHTML = `<div class="alert alert-danger">Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.</div>`;
                that.resetForm();
              },
            });
          })
          .catch(() => {
            // Kein Consent oder Script nicht geladen → Nutzer informieren
            const messageContainer = document.getElementById('form-messages');
            messageContainer.innerHTML = `<div class="alert alert-warning">reCAPTCHA ist nicht aktiv. Bitte erteile die Einwilligung in den Cookie‑Einstellungen und versuche es erneut.</div>`;
          });

        return false; // Standard-Submit verhindern
      },

    });

  }

  onResize = () => {
    $(window)
      .resize(function () {
        iso.layout();
      })
      .resize();
  };

  resetForm = () => {
    jQuery('#name').val('');
    jQuery('#email').val('');
    jQuery('#message').val('');
    jQuery('#policy').prop('checked', false);
  }


}


export default Home;
